import { Link } from '@inertiajs/react';
import { closedMessage } from '../../config';
import type { School } from '../../types';

import styles from './school-item.module.css';

function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

type Props = {
  school: School;
};

export function SchoolItem(props: Props) {
  const { school } = props;
  const { id, address, name, nameJp, studentCapacity, isClosed } = school;

  return (
    <Link className={styles.root} href={`/school/${id}/`} prefetch>
      {isClosed && <div className={styles.closed} title={closedMessage} />}
      <div className={styles.image} style={{ backgroundImage: `url(/storage/schools/${id}.jpg)` }} />
      <div>
        <h2 className={styles.title}>{toTitleCase(name)}</h2>
        <h2 className={styles.titlejp}>{nameJp}</h2>
      </div>
      <div className={styles.item}>
        <label className={styles.label}>Address</label>
        <span className={styles.value}>{address}</span>
      </div>
      <div className={styles.item}>
        <label className={styles.label}>Student capacity</label>
        <span className={styles.value}>{studentCapacity}</span>
      </div>
    </Link>
  );
}
